import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon, DownloadIcon, LoaderIcon } from 'lucide-react';
interface SlideNavigationProps {
  current: number;
  total: number;
  onNext: () => void;
  onPrev: () => void;
  onGoTo: (index: number) => void;
  onDownloadPDF: () => void;
  isGeneratingPDF: boolean;
}
export function SlideNavigation({
  current,
  total,
  onNext,
  onPrev,
  onGoTo,
  onDownloadPDF,
  isGeneratingPDF
}: SlideNavigationProps) {
  return <div className="fixed bottom-0 left-0 right-0 h-14 sm:h-20 bg-white/80 backdrop-blur-md border-t border-slate-200 flex items-center justify-between px-3 sm:px-6 md:px-8 z-50" data-id="element-11">
      <div className="flex items-center gap-2 sm:gap-4" data-id="element-12">
        <button onClick={onPrev} disabled={current === 0} className="p-1.5 sm:p-2 rounded-full hover:bg-slate-100 disabled:opacity-30 disabled:hover:bg-transparent transition-colors text-slate-900 touch-manipulation" aria-label="Previous slide" data-id="element-13">
          <ChevronLeftIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-14" />
        </button>
        <span className="text-xs sm:text-sm font-medium text-slate-500 font-heading tabular-nums" data-id="element-15">
          {String(current + 1).padStart(2, '0')} /{' '}
          {String(total).padStart(2, '0')}
        </span>
        <button onClick={onNext} disabled={current === total - 1} className="p-1.5 sm:p-2 rounded-full hover:bg-slate-100 disabled:opacity-30 disabled:hover:bg-transparent transition-colors text-slate-900 touch-manipulation" aria-label="Next slide" data-id="element-16">
          <ChevronRightIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-17" />
        </button>
      </div>

      <div className="flex items-center gap-1 sm:gap-2 overflow-x-auto max-w-[40vw] sm:max-w-none scrollbar-hide" data-id="element-18">
        {Array.from({
        length: total
      }).map((_, i) => <button key={i} onClick={() => onGoTo(i)} className={`shrink-0 h-1.5 rounded-full transition-all duration-300 touch-manipulation ${i === current ? 'w-5 sm:w-8 bg-gold-500' : 'w-1.5 sm:w-2 bg-slate-300 hover:bg-slate-400'}`} aria-label={`Go to slide ${i + 1}`} data-id="element-19" />)}
      </div>

      <div className="hidden md:flex items-center gap-4" data-id="element-20">
        <button onClick={onDownloadPDF} disabled={isGeneratingPDF} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gold-500/15 border border-gold-500/30 text-gold-600 text-sm font-medium hover:bg-gold-500/25 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" aria-label="Download PDF" data-id="element-21">
          {isGeneratingPDF ? <>
              <LoaderIcon className="w-4 h-4 animate-spin" data-id="element-22" />
              <span data-id="element-23">Generating…</span>
            </> : <>
              <DownloadIcon className="w-4 h-4" data-id="element-24" />
              <span data-id="element-25">Download PDF</span>
            </>}
        </button>
        <img src="https://cdn.magicpatterns.com/uploads/5yQmgLdmxXwt1kmPQacBfs/Logo_Digilite_New-01.png" alt="Digilite" className="h-[34px] opacity-90" data-id="element-26" />
      </div>
    </div>;
}
;
'>';